






























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { IImage } from "@/types/image";
import { Image } from "@/models/image";

@Component({
  components: {}
})
export default class extends Vue {
  @Action("image/adminGetList")
  public getImageList!: (site_id: number) => boolean;
  @Action("image/adminGetManifestList")
  public getManifestList!: (site_id: number) => boolean;

  @Getter("image/list")
  public images!: IImage[];
  @Mutation("image/clear")
  public clear!: () => void;
  @Prop({ default: "image" })
  public type!: string;

  public site_id = 0;
  public manifest_id = 10;
  public transparent = "rgba(255, 255, 255, 0)";
  public dialog = false;
  public selectedImage: IImage = new Image();
  public nextImage: IImage | null = null;
  public beforeImage: IImage | null = null;

  public async created() {
    this.site_id = Number(this.$route.params.site_id);
    this.clear();
    if (this.type != "manifest") {
      await this.getImageList(this.site_id);
    } else {
      await this.getManifestList(this.site_id);
    }
  }

  private imageSelect() {
    this.images.forEach((img: IImage, index: number) => {
      if (img.id === this.selectedImage.id) {
        this.nextImage = this.images[index + 1] ?? null;
        this.beforeImage = this.images[index - 1] ?? null;
      }
    });
  }

  public openDialog(image: IImage) {
    this.selectedImage = image;
    this.imageSelect();
    this.dialog = true;
  }

  public dialogNext() {
    if (this.nextImage) {
      this.selectedImage = this.nextImage;
      this.imageSelect();
    }
  }

  public dialogBegore() {
    if (this.beforeImage) {
      this.selectedImage = this.beforeImage;
      this.imageSelect();
    }
  }
}
